import { render, staticRenderFns } from "./Notification_Admin.vue?vue&type=template&id=f02bfdc6&scoped=true&"
import script from "./Notification_Admin.vue?vue&type=script&lang=js&"
export * from "./Notification_Admin.vue?vue&type=script&lang=js&"
import style0 from "./Notification_Admin.vue?vue&type=style&index=0&id=f02bfdc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02bfdc6",
  null
  
)

export default component.exports